import { useAuth } from '@/lib/auth';

/**
 * Check if the current user has the tenant-owner Zitadel role.
 * Replaces the old DB-based hasRole('Owner') check.
 */
export function useIsTenantOwner(): boolean {
  const { hasRole } = useAuth();
  return hasRole('tenant-owner');
}
